import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

const routes: Routes = [
  {
    path: "auth",
    loadChildren: () =>
      import("./auth/auth.module").then((m) => m.AuthPageModule),
  },
  {
    path: "a/:qrcode",
    loadChildren: () =>
      import("./invitation-accept/invitation-accept.module").then(
        (m) => m.InvitationAcceptPageModule
      ),
  },
  {
    path: "legal",
    loadChildren: () =>
      import("./legal/legal.module").then((m) => m.LegalPageModule),
  },
  {
    path: "p/:IdBooking",
    loadChildren: () =>
      import("./open-barierr/open-barierr.module").then(
        (m) => m.OpenBarierrComponentModule
      ),
  },
  {
    path: "push-acceptation",
    loadChildren: () =>
      import("./push-acceptation/push-acceptation.module").then(
        (m) => m.PushAcceptationPageModule
      ),
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class PublicRoutingModule {}
